const artistsFR = {
    "view": {
        "table": {
            "title": "Votre liste d'artistes",
            "column": {
                "name": "Nom de l'artiste",
                "owner": "Propriétaire",
                "spotify_link": "Lien Spotify",
                "apple_music_link": "Lien Apple Music",
                "amazon_music_link": "Lien Amazon Music",
                "deezer_link": "Lien Deezer",
                "flagged": "Signalé",
                "blacklisted": "Liste noire",
                "action": "Action"
            },
            "button": {
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "message": {
                "artistFlagged": "Cet artiste est signalé et un paiement sous séquestre est requis pour distribuer la sortie sur Spotify.",
                "artistNotFlagged": "Cet artiste est éligible pour la distribution sur Spotify.",
                "artistBlacklisted": "Cet artiste est sur la liste noire et non éligible pour la distribution.",
                "artistNotBlacklisted": "Cet artiste n'est pas sur la liste noire et est éligible pour la distribution.",
            }
        },
        "message": {
            "success": "L'artiste a été supprimé !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "notSubscribed": "Vous n'êtes abonné à aucun plan, par conséquent, vous ne pouvez ajouter que <strong>3 artistes</strong>, veuillez <3>souscrire</3> à un plan pour bénéficier d'un nombre illimité d'artistes.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "L'artiste {{artistName}} ne peut pas être supprimé",
                "body": "L'artiste {{artistName}} ne peut pas être supprimé car il a déjà des pistes/sorties associées."
            },
            "delete": {
                "header": "Supprimer {{artistName}} ?",
                "body": "Êtes-vous sûr de vouloir vraiment supprimer cet artiste ? Cette action pourrait détacher votre artiste de la sortie assignée."
            },
            "edit": {
                "header": "Modifier {{artistName}} ?",
                "body": "Êtes-vous sûr de vouloir changer le nom de votre artiste ? Cela pourrait avoir un effet sur les métadonnées de la sortie."
            }
        }
    },
    "add": {
        "title": "Ajouter un artiste",
        "form": {
            "label": {
                "is_new_artist": "Est un nouvel artiste",
                "spotify_profile": "Profil Spotify",
                "deezer_profile": "Profil Deezer",
                "amazon_music_profile": "Profil Amazon Music",
                "spotify_image": "Image Spotify",
                "deezer_image": "Image Deezer",
                "amazon_music_image": "Image Amazon Music",
                "spotify_id": "ID Spotify",
                "deezer_id": "ID Deezer",
                "amazon_music_id": "ID Amazon Music",
                "apple_id": "ID Apple",
                "name": "Nom",
                "name_preference": "Préférence de nom",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sous-utilisateur"
            },
            "help_text": {
                "is_new_artist": "Ajoutez-vous un nouvel artiste, c'est-à-dire si votre artiste a des sorties sur Spotify/Deezer/Amazon Music/Apple Music, sélectionnez Non sinon sélectionnez Oui.",
                "spotify_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Spotify, sinon cliquez sur le bouton Non trouvé.",
                "deezer_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Deezer, sinon cliquez sur le bouton Non trouvé.",
                "amazon_music_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Amazon Music, sinon cliquez sur le bouton Non trouvé.",
                "apple_id": "Remarque : Utilisez ce champ uniquement si vous souhaitez ajouter un artiste déjà sur Apple Music, sinon cliquez sur le bouton Non trouvé.",
                "subuser": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste pour l'un de vos sous-utilisateurs, sinon laissez non sélectionné."
            },
            "placeholder": {
                "subuser": "Sélectionner un sous-utilisateur...",
                "spotify_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ID Spotify de l'artiste, par exemple, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ID Deezer de l'artiste, par exemple, 1406580",
                "amazon_music_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ASIN Amazon de l'artiste, par exemple, B005GI0T2U",
                "apple_id": "Veuillez entrer un ID Apple valide. Exemple : 635806095"
            },
            "button": {
                "reset": "Réinitialiser",
                "not_found": "Non trouvé",
                "submit": "Soumettre"
            },
            "option": {
                "yes": "Oui",
                "no": "Non"
            },
            "validation": {
                "name_required": "Le nom est requis",
                "name_invalid": "Le nom de l'artiste doit contenir 'DJ' uniquement en majuscules",
                "email_required": "L'email est requis",
                "email_invalid": "Veuillez entrer un email valide",
                "name_duplicate": "L'artiste existe déjà",
                "name_mismatch": "Le nom de l'artiste doit correspondre pour tous les magasins",
                "spotify_id_invalid": "Veuillez ajouter un ID Spotify valide. Exemple : 6eUKZXaKkcviH0Ku9w2n3B. Consultez notre Centre d'aide pour plus d'informations.",
                "apple_id_required": "L'ID Apple est requis",
                "apple_id_invalid": "Veuillez ajouter un ID Apple valide. Exemple : 635806095. Consultez notre Centre d'aide pour plus d'informations."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Déclaration de nouvel artiste",
                "profile_not_present_declaration": "Déclaration de profil non présent"
            },
            "body": {
                "profile_not_present_declaration": "Je confirme que le profil de cet artiste n'est pas présent sur <strong>{{store}}</strong> et que le profil de cet artiste soit créé fraîchement sur <strong>{{store}}</strong>.",
                "new_artist_declaration": "Je confirme que le profil de cet artiste n'est pas présent sur aucun des magasins suivants et que le profil de cet artiste soit créé fraîchement sur ces magasins.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Confirmer",
                "cancel": "Annuler"
            }
        },
        "message": {
            "success": "L'artiste a été ajouté !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "errorBlacklisted": "Une ou plusieurs des détails que vous avez fournis sont liés à un artiste qui est sur la liste noire. Si vous êtes sûr que l'artiste n'est pas sur la liste noire, veuillez contacter l'équipe de support pour plus d'informations."

        }
    },
    "update": {
        "title": "Modifier l'artiste",
        "form": {
            "label": {
                "spotify_profile": "Profil Spotify",
                "deezer_profile": "Profil Deezer",
                "amazon_music_profile": "Profil Amazon Music",
                "spotify_image": "Image Spotify",
                "deezer_image": "Image Deezer",
                "amazon_music_image": "Image Amazon Music",
                "spotify_id": "ID Spotify",
                "deezer_id": "ID Deezer",
                "amazon_music_id": "ID Amazon Music",
                "apple_id": "ID Apple",
                "name": "Nom",
                "name_preference": "Préférence de nom",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "flagged": "Signalé"
            },
            "help_text": {
                "spotify_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Spotify, sinon cliquez sur le bouton Non trouvé.",
                "deezer_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Deezer, sinon cliquez sur le bouton Non trouvé.",
                "amazon_music_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Amazon Music, sinon cliquez sur le bouton Non trouvé.",
                "apple_id": "Remarque : Utilisez ce champ uniquement si vous souhaitez ajouter un artiste déjà sur Apple Music, sinon cliquez sur le bouton Non trouvé."
            },
            "placeholder": {
                "spotify_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ID Spotify de l'artiste, par exemple, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ID Deezer de l'artiste, par exemple, 1406580",
                "amazon_music_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ASIN Amazon de l'artiste, par exemple, B005GI0T2U",
                "apple_id": "Veuillez entrer un ID Apple valide. Exemple : 635806095"
            },
            "button": {
                "reset": "Réinitialiser",
                "not_found": "Non trouvé",
                "submit": "Soumettre"
            },
            "validation": {
                "name_required": "Le nom est requis",
                "email_required": "L'email est requis",
                "email_invalid": "Veuillez entrer un email valide",
                "name_duplicate": "L'artiste existe déjà",
                "name_mismatch": "Le nom de l'artiste doit correspondre pour tous les magasins",
                "name_mismatch_spotify": "Le nom du profil Spotify doit correspondre au nom de l'artiste",
                "name_mismatch_deezer": "Le nom du profil Deezer doit correspondre au nom de l'artiste",
                "name_mismatch_amazon_music": "Le nom du profil Amazon doit correspondre au nom de l'artiste",
                "spotify_id_invalid": "Veuillez ajouter un ID Spotify valide. Exemple : 6eUKZXaKkcviH0Ku9w2n3B. Consultez notre Centre d'aide pour plus d'informations.",
                "apple_id_required": "L'ID Apple est requis",
                "apple_id_invalid": "Veuillez ajouter un ID Apple valide. Exemple : 635806095. Consultez notre Centre d'aide pour plus d'informations."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Déclaration de réinitialisation de profil",
                "profile_not_present_declaration": "Déclaration de profil non présent"
            },
            "body": {
                "profile_not_present_declaration": "Je confirme que le profil de cet artiste n'est pas présent sur <strong>{{store}}</strong> et que le profil de cet artiste soit créé fraîchement sur <strong>{{store}}</strong>.",
                "profile_reset_declaration": "Je suis conscient qu'en réinitialisant le profil <strong>{{store}}</strong> de cet artiste, l'<strong>ID {{store}}</strong> sera supprimé de partout dans le système et cela est susceptible de causer des perturbations dans les magasins et des erreurs d'association des artistes."
            },
            "button": {
                "confirm": "Confirmer",
                "cancel": "Annuler"
            }
        },
        "message": {
            "success": "L'artiste nommé '{{artistName}}' a été mis à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "errorBlacklisted": "Une ou plusieurs des détails que vous avez fournis sont liés à un artiste qui est sur la liste noire. Si vous êtes sûr que l'artiste n'est pas sur la liste noire, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "add_from_wishlist": {
        "title": "Ajouter un artiste",
        "form": {
            "label": {
                "spotify_profile": "Profil Spotify",
                "deezer_profile": "Profil Deezer",
                "amazon_music_profile": "Profil Amazon Music",
                "spotify_id": "ID Spotify",
                "spotify_image": "Image Spotify",
                "deezer_id": "ID Deezer",
                "deezer_image": "Image Deezer",
                "amazon_music_id": "ID Amazon",
                "amazon_music_image": "Image Amazon Music",
                "apple_id": "ID Apple",
                "apple_image": "Image Apple",
                "name": "Nom",
                "name_preference": "Préférence de nom",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sous-utilisateur"
            },
            "placeholder": {
                "spotify_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ID Spotify de l'artiste, par exemple, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ID Deezer de l'artiste, par exemple, 1406580",
                "amazon_music_profile": "Entrez le nom de l'artiste, par exemple, The Weekend ou l'ASIN Amazon de l'artiste, par exemple, B005GI0T2U",
                "apple_id": "Veuillez entrer un ID Apple valide. Exemple : 635806095",
                "subuser": "Sélectionner un sous-utilisateur..."
            },
            "help_text": {
                "spotify_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Spotify, sinon cliquez sur le bouton Non trouvé.",
                "deezer_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Deezer, sinon cliquez sur le bouton Non trouvé.",
                "amazon_music_profile": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste déjà sur Amazon Music, sinon cliquez sur le bouton Non trouvé.",
                "apple_id": "Remarque : Utilisez ce champ uniquement si vous souhaitez ajouter un artiste déjà sur Apple Music, sinon cliquez sur le bouton Non trouvé.",
                "subuser": "Remarque : Utilisez cette liste déroulante uniquement si vous souhaitez ajouter un artiste pour l'un de vos sous-utilisateurs, sinon laissez non sélectionné."
            },
            "button": {
                "reset": "Réinitialiser",
                "notFound": "Non trouvé ?",
                "submit": "Soumettre",
                "cancel": "Annuler",
                "confirm": "Confirmer"
            },
            "validation": {
                "name_required": "Le nom est requis",
                "email_required": "L'email est requis",
                "email_invalid": "Veuillez entrer un email valide",
                "spotify_id_invalid": "Veuillez ajouter un ID Spotify valide. Exemple : 6eUKZXaKkcviH0Ku9w2n3B. Consultez notre Centre d'aide pour plus d'informations.",
                "apple_id_required": "L'ID Apple est requis",
                "apple_id_invalid": "Veuillez ajouter un ID Apple valide. Exemple : 635806095. Consultez notre Centre d'aide pour plus d'informations."
            },
            "message": {
                "errorArtistExists": "L'artiste existe déjà",
                "errorNameMismatch": "Le nom de l'artiste doit correspondre pour tous les magasins",
                "errorSpotifyNameMismatch": "Le nom du profil Spotify doit correspondre au nom de l'artiste",
                "errorDeezerNameMismatch": "Le nom du profil Deezer doit correspondre au nom de l'artiste",
                "errorAmazonNameMismatch": "Le nom du profil Amazon doit correspondre au nom de l'artiste"
            }
        },
        "message": {
            "success": "L'artiste a été ajouté !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "errorBlacklisted": "Une ou plusieurs des détails que vous avez fournis sont liés à un artiste qui est sur la liste noire. Si vous êtes sûr que l'artiste n'est pas sur la liste noire, veuillez contacter l'équipe de support pour plus d'informations."
        },
        "modal": {
            "profileMissing": {
                "header": "Déclaration de profil non présent",
                "body": "Je confirme que le profil de cet artiste n'est pas présent sur <strong>{{storeName}}</strong> et que le profil de cet artiste soit créé fraîchement sur <strong>{{storeName}}</strong>.",
                "button": {
                    "cancel": "Annuler",
                    "confirm": "Confirmer"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "ABONNÉS",
                "popularity": "POPULARITÉ",
                "genres": "GENRES",
                "flagged": "SIGNALÉ",
                "notAvailable": "Non disponible",
                "notAvailableAbbr": "N/D"
            },
            "similarArtists": {
                "title": "Artistes similaires",
                "table": {
                    "column": {
                        "artist": "Artiste",
                        "followers": "Abonnés",
                        "popularity_pct": "Popularité (%)",
                        "genres": "Genres",
                        "wishlist": "Liste de souhaits"
                    }
                },
                "label": {
                    "notAvailable": "Non disponible",
                    "notAvailableAbbr": "N/D"
                },
                "message": {
                    "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Ajouter l'artiste {{artistName}} à la liste de souhaits",
                        "body": "Êtes-vous sûr de vouloir ajouter l'artiste {{artistName}} à votre liste de souhaits ?",
                        "message": {
                            "success": "L'artiste a été ajouté à la liste de souhaits !"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Retirer l'artiste {{artistName}} de la liste de souhaits",
                        "body": "Êtes-vous sûr de vouloir retirer l'artiste {{artistName}} de votre liste de souhaits ?"
                    }
                }
            },
            "topTracks": {
                "title": "Meilleurs titres",
                "table": {
                    "column": {
                        "track": "Titre",
                        "release": "Sortie",
                        "artists": "Artiste(s)",
                        "popularity_pct": "Popularité (%)",
                        "preview": "Aperçu"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Votre navigateur ne prend pas en charge l'élément audio."
                }
            }
        }
    }
};

export default artistsFR;